import React from "react";
import "../styles/contact.css";

export default function Contact() {
  return (
    <section className="contact-page">
      <h1>Contact Lak Derana Cabs</h1>
      <p className="tagline">
        We’re always here to take your call — 24/7 reliable taxi service across Kurunegala and beyond.
      </p>

      <div className="contact-grid">
        {/* ---- CALL US ---- */}
        <div className="contact-card">
          <h2>
            <i className="fa-solid fa-phone"></i> Call Us
          </h2>
          <a href="tel:0774504505" className="phone primary">
            077 450 450 5
          </a>
          <a href="tel:0717755255" className="phone alt">
            071 775 5255
          </a>
        </div>

        {/* ---- WHATSAPP ---- */}
        <div className="contact-card whatsapp">
          <h2>
            <i className="fa-brands fa-whatsapp"></i> WhatsApp
          </h2>
          <p>Fast replies for bookings & quotes</p>
          <a
            href="https://wa.me/94773662322"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp"
          >
            <i className="fa-brands fa-whatsapp"></i> Chat on WhatsApp
          </a>
        </div>

        {/* ---- VISIT US ---- */}
        <div className="contact-card">
          <h2>
            <i className="fa-solid fa-location-dot"></i> Visit Us
          </h2>
          <p>
            279 Kurunegala – Dambulla Rd, <br />
            Polatthapitiya 60000, Sri Lanka
          </p>

          {/* ✅ Updated Working Google Map */}
          <iframe
            title="Lak Derana Cabs Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5594.21967463754!2d80.36978467509034!3d7.497161403600532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae3391c435d0f3d%3A0x451d9bc10bae58a4!2sLak%20Derana%20Cabs%20%E2%80%93%20Kurunegala%20Taxi%20Service!5e0!3m2!1sen!2slk!4v1762790287451!5m2!1sen!2slk"
            width="100%"
            height="350"
            style={{
              border: 0,
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* ---- WORKING HOURS ---- */}
        <div className="contact-card">
          <h2>
            <i className="fa-regular fa-clock"></i> Working Hours
          </h2>
          <p>Open 24 hours, 7 days a week.</p>
          <p className="note">
            Call or WhatsApp us anytime for instant bookings.
          </p>
        </div>
      </div>
    </section>
  );
}
